import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { form, Text, FormGroup, Select } from '../../atoms/Forms'
import { Col, Row } from '../../atoms/Grid'
import Button from '../../atoms/Button'
import Alert from '../../atoms/Alert'
import Loading from '../../atoms/Loading'

import T from '../../../translate/T'

import * as userData from '../../../utils/userData'

class UpdateProfileFields extends Component {
    constructor(props) {
        super(props)
        this.state = {
            form: {},
            error: '',
            status: 'done'
        }

        this.onChange = this.onChange.bind(this)
    }

    componentWillMount() {
        let form = {}
        for (let i = 0; i < this.props.fields.length; i++) {
            const element = this.props.fields[i]
            form[element.name] = element.value
        }
        this.setState({
            ...this.state,
            form
        })
    }

    onSubmit(e) {
        e.preventDefault()
        let form = {
            ...this.state.form
        }

        for (let i = 0; i < this.props.fields.length; i++) {
            const element = this.props.fields[i]
            let idx = null
            if(element.type === 'select') {
                idx = element.options.indexOf(form[element.name])
            }
            if(!form[element.name] || form[element.name] === '' || (element.type === 'select' && idx < 0)) {
                
                this.setState({
                    ...this.state,
                    error: T.txt('fill_field', {
                        field: element.label
                    })
                })
                return false
            }
        }

        this.setState({
            status: 'loading'
        })
        
        userData.saveSurvey(form)
        .then(resp => {
            let error = ''
            if(resp.errors) {
                error = resp.errors[0].message
            }
            
            this.setState({
                status: 'done',
                error
            })

            if(!resp.errors)
            this.props.onUpdate()
        })
    }

    onChange(e) {
        this.setState( form(this.state.form, e.target) )
    }

    render() {
        
        return (
            <form onSubmit={(e) => this.onSubmit(e)}>
                {this.state.error && (
                    <div style={{textAlign: 'left'}}>
                        <Alert type='danger'>
                            {this.state.error}
                        </Alert>
                    </div>
                )}
                <Row>
                    {this.props.fields.map( field => (
                        <Col size={12} float='center' key={field.name}>
                            <FormGroup>
                                { field.type === 'text' && (
                                    <Text
                                        name={field.name}
                                        handleChange={this.onChange}
                                        value={this.state.form[field.name]}
                                        placeholder={field.label}
                                        mask={field.mask}
                                    />
                                )}

                                { field.type === 'select' && (
                                    <Select
                                        name={field.name}
                                        handleChange={this.onChange}
                                        value={this.state.form[field.name]}
                                        placeholder={field.label}
                                        mask={field.mask}
                                    >
                                        <option value=''>
                                            {field.label}
                                        </option>
                                        { field.options.map( option =>
                                            <option key={option} value={option}>
                                                {option}
                                            </option>
                                        )}
                                    </Select>
                                )}
                            </FormGroup>
                        </Col>
                    ))}
                </Row>
                
                
                <Col size='12' text='center'>
                    <Button
                        inline
                        color='orange'
                        disabled={this.state.status === 'loading'}>
                        { this.state.status === 'loading' ? 
                        ( <Loading color='#fff' /> )
                        : T.txt('continue') }
                    </Button>
                </Col>
                
                
            </form>
        )
    }
}

const mapStateToProps = state => ({})
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(UpdateProfileFields)


// WEBPACK FOOTER //
// ./src/components/forms/UpdateUserData/index.js